import {RestServiceAbstract} from '../../abstracts/rest-service.abstract';
import {map, takeUntil} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {Observable, Subject, throwError} from 'rxjs';
import {Response} from '../../models/response.model';
import {catchError} from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class CommunicationRestService extends RestServiceAbstract {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    public loadTemplates() {
        return this.get(`/usermanagement/admin/communication/templates`).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    public saveTemplates(rq) {
        return this.post(`/usermanagement/admin/communication/templates`, rq).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    public editTemplates(rq) {
        return this.put(`/usermanagement/admin/communication/templates`, rq).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    public deleteTemplates(rq) {
        return this.delete(`/usermanagement/admin/communication/templates`, {body: rq}).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }


    public loadMessages(page, size, filter: string, sort: any) {
        return this.get(`/usermanagement/admin/communication/messages`, {
            params: {
                s: filter,
                page: page,
                size: size,
                sort: `${sort.field},${sort.direction}`
            }
        }).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    public saveMessage(rq) {
        return this.post(`/usermanagement/admin/communication/messages`, rq).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    public editMessage(id, rq) {
        return this.put(`/usermanagement/admin/communication/messages/${id}`, rq).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    public updateMessageEndDate(id, rq) {
        return this.put(`/usermanagement/admin/communication/messages/${id}/end-date`, rq).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    public deleteMessage(rq) {
        return this.delete(`/usermanagement/admin/communication/messages/${rq}`, {}).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    public publishMessage(rq) {
        return this.post(`/usermanagement/admin/communication/messages/publish`, rq).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    public getMessage(rq) {
        return this.get(`/usermanagement/admin/communication/messages/${rq}`).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    public getActiveMessages(rq) {
        return this.get(`/usermanagement/admin/communication/messages/active`).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    public getMessagesChildren(id) {
        return this.get(`/usermanagement/admin/communication/messages/children`, {params: {id: id}}).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    public getRecipientsDetails(rq, page, size, filter: string, sort: any) {
        return this.get(`/usermanagement/admin/communication/messages/${rq}/recipients`, {
            params: {
                s: filter,
                page: page,
                size: size,
                sort: `${sort.field},${sort.direction}`
            }
        }).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    getNumberOfRecipients(rq) {
        return this.post(`/usermanagement/admin/communication/messages/recipients`, rq).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    getCommunicationSubscriptions(): Observable<Response> {
        return this.get('/synchronizer/export/delivery-subscribers').pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => {
                return new Response(data);
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }
}
